// Landing-stage TikTok pixel. Loads the TikTok SDK and fires
// `ViewContent` with NO `value`/`currency` — a content view is not a
// valued conversion, and this surface cannot know the price (see
// cookie-trackers-landing.tsx for the invariant). Revenue is asserted
// once, at /post-purchase, from the Stripe-resolved amount.
//
// An inline-script body so the `strToInlineScript()` pattern in
// `seo.ts` keeps working.
export const tiktokPixelScript = `
/* eslint-disable -- inline pixel script, vendor-shaped js */
!((w, _d, t) => {
  w.TiktokAnalyticsObject = t;
  const ttq = (w[t] = w[t] || []);
  ((ttq.methods = [
    'page', 'track', 'identify', 'instances', 'debug', 'on', 'off',
    'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie',
  ]),
    (ttq.setAndDefer = (t, e) => {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    }));
  for (let i = 0; i < ttq.methods.length; i++)
    ttq.setAndDefer(ttq, ttq.methods[i]);
  ((ttq.instance = (t) => {
    const e = ttq._i[t] || [];
    for (let n = 0; n < ttq.methods.length; n++)
      ttq.setAndDefer(e, ttq.methods[n]);
    return e;
  }),
    (ttq.load = (e, n) => {
      const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ((ttq._i = ttq._i || {}),
        (ttq._i[e] = []),
        (ttq._i[e]._u = i),
        (ttq._t = ttq._t || {}),
        (ttq._t[e] = Date.now()),
        (ttq._o = ttq._o || {}),
        (ttq._o[e] = n || {}));
      n = document.createElement('script');
      ((n.type = 'text/javascript'),
        (n.async = !0),
        (n.src = \`\${i}?sdkid=\${e}&lib=\${t}\`));
      e = document.getElementsByTagName('script')[0];
      e.parentNode.insertBefore(n, e);
    }));
  ttq.load('CHQCEJBC77U8RIVT2S60');
  ttq.page();
})(window, document, 'ttq');
ttq.track('ViewContent', {
  contents: [{ content_id: '100', content_name: 'unlimited_listening' }],
});
`;
